export const TEST_ENVIRONMENTS = ['QA', 'QA-LOCAL', 'DEV', 'DEV-LOCAL', 'QAANTD', 'DEVIM'];
export const LIVE_ENVIRONMENTS = ['STAGE', 'PROD-LOCAL', 'PROD'];
export const NOT_PROD_ENV = ['QA', 'QA-LOCAL', 'DEV', 'DEV-LOCAL', 'STAGE'];

const DEFAULT_FEATURES = {
  PLAYWRIGHT_MAP_INJECT: false, //Should always remain false. Used for playwright tests of the world map.
  MGNM_810: false,
  MAPI_191: false,
  MASSNOTIF_917: true, // AKA HZMN_380
  MGNMSTS_213: false,
  FUZ_122: false, // AKA HZFE_340
  FUZ_124: false, // AKA HZFE_337
  AMP_48: false, // AKA HZMN_375
  AMP_52: true, // AKA HZMN_372
  PDM_100: true,
  PDM_110: true, // AKA HZDI_205
  MPM_3: false,
  MPM_4: false,
  MPM_9: true,
  PR_46: false,
  HPFJD_12: true,
  MASSNOTIF_888: true,
  HZFE_237: true,
  AMP_47: false, //AKA HZMN_373
  AMP_54: true, //AKA HZMN_374
  MGNMSTS_403: true,
  PDM_85: true,
  MASSNOTIF_891: false, // deploy cdn
  AMP_98: false, // AKA HZMN_369
  AMP_81: false,
  HZDI_79: true,
  MAPI_326: false,
  MAPI_331: false,
  MAPI_332: false,
  MAPI_333: false,
  MAPI_334: false,
  MAPI_335: false,
  MAPI_336: false,
  MAPI_337: false,
  MAPI_338: false,
  MAPI_339: false,
  MAPI_328: false,
  MAPI_341: false,
  MAPI_342: false,
  MAPI_343: false,
  MAPI_344: false,
  MAPI_345: false,
  MAPI_327: false,
  MAPI_340: false,
  MAPI_329: false,
  MAPI_346: false,
  HZFE_6: true,
  HZFE_19: true,
  HZFE_20: true,
  HZFE_60: true,
  FUZ_4: false,
  HZFE_87: false,
  HZFE_89: true,
  HZFE_94: true,
  HPFJD_18: true,
  HZMN_51: false,
  HZFE_58: false,
  HZFE_134: true,
  HZFE_139: true,
  FUZ_84: true,
  HZFE_88: true,
  HZFE_179: true,
  HZFE_174: true,
  HZFE_289: true,
  HZDI_174: false,
  HZDI_168: false,
  HZMN_233: false,
  HZMN_350: false,
  HZMN_237: false,
  HZMN_248: false,
  HZMN_331: true,
  HZMN_361: false,
  HZMN_441: false,
  HZFE_138: true,
  HZFE_78: true,
  HZFE_51: false,
  HZDI_183: false,
  HZFE_334: false,
  HZDI_92: false,
  HZFE_258: true,
  HZFE_262: false,
  HZDI_184: true,
  HZFE_351: false,
  HZDI_221: true,
  HZFE_145: true,
  HZFE_434: false,
  HZFE_248: false,
  HZFE_350: true,
  MAP_THREATZONE_DRAWERS: false,
  MAP_ALERTS_DRAWERS: false,
  MAP_PERSONS_DRAWERS: false,
  MAP_SITES_DRAWERS: false,
  MAP_RATINGS_DRAWERS: false,
  MAP_SECURITY_DRAWERS: false,
  MAP_SELECTION_DRAWER: false,
  MAP_POLYGON_DRAWER: false,
  MAP_NAV_ALERTS_DETAILS: false,
  MAP_NAV_LOCATION_DETAILS: false,
  MAP_NAV_PERSON_DETAILS: false,
  MAP_NAV_SITE_PROFILE: false,
  HZFE_64: false,
  MAP_FILTERS_CONTEXT: false,
  MAP_SAVED_VIEWS: false,
  HZFE_230: false,
  HZFE_231: false,
};

export const LOCAL_STORAGE_KEY = 'FEATURE_TOGGLE_ENABLE_OVERRIDE';

let featureToggleOverrides = {};

if (TEST_ENVIRONMENTS.includes(process.env.REACT_APP_ENVIRONMENT)) {
  const raw = localStorage.getItem(LOCAL_STORAGE_KEY);

  if (typeof raw === 'string' && raw.trim().startsWith('{')) {
    try {
      const parsed = JSON.parse(raw);

      // Set featureToggleOverrides and filter out invalid keys.
      featureToggleOverrides = Object.fromEntries(Object.entries(parsed).filter(([key]) => key in DEFAULT_FEATURES));
    } catch (e) {
      console.error(`[FeatureToggle] Failed to parse ${LOCAL_STORAGE_KEY} from localStorage:`, e);
    }
  }
}

export const FEATURES = {
  ...DEFAULT_FEATURES,
  ...featureToggleOverrides,
};
